export default "/images/75a535706f5c6733d44211593ce72aed.jpg";